export default __webpack_public_path__ + "static/heart_blue-a8a33daa942810c0bfce14c1f93ae343.png";